// extracted by mini-css-extract-plugin
var _1 = "ViewEntireMessageButton-moduleViewEntireMessageButton__e0zZf";
export { _1 as "ViewEntireMessageButton" }
